import { Button } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconSpeakerphone } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { AssetAnnouncementsModal } from 'src/Components/Modals/AssetAnnouncementsModal';
import useFetchUser from 'src/Hooks/Queries/useFetchUser';

import styles from './DashboardHeader.module.scss';

const DashboardHeader = () => {
  const { t } = useTranslation();
  const { data: user } = useFetchUser();
  const [opened, { open, close }] = useDisclosure(false);

  const hour = new Date().getHours();
  const greeting =
    hour < 12
      ? t('dashboard.goodMorning', 'Bonjour')
      : hour < 18
        ? t('dashboard.goodAfternoon', 'Bon après-midi')
        : t('dashboard.goodEvening', 'Bonsoir');

  return (
    <div className={styles.container}>
      <div className={styles.text}>
        <h1 className={styles.greeting}>
          {greeting}
          {user?.firstName ? ` ${user.firstName}` : ''}
        </h1>
      </div>
      <Button variant="outline" leftSection={<IconSpeakerphone size={18} />} onClick={open}>
        {t('dashboard.createAnnouncement', 'Publier une annonce')}
      </Button>
      <AssetAnnouncementsModal open={opened} onClose={close} />
    </div>
  );
};

export default DashboardHeader;
